import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x",
  "use": "icon-x-usage",
  "viewBox": "0 0 26 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 25\" id=\"icon-x\"><path d=\"M4.667 0A4.167 4.167 0 0 0 .5 4.167v16.666A4.167 4.167 0 0 0 4.667 25h16.666a4.167 4.167 0 0 0 4.167-4.167V4.167A4.167 4.167 0 0 0 21.333 0H4.667Zm1.241 5.357h4.725l3.355 4.768 4.072-4.768h1.488L14.66 11.08l6.027 8.564h-4.724L12.07 14.11l-4.725 5.532H5.857l5.541-6.486-5.49-7.8Zm2.279 1.19 8.397 11.905h1.824L10.011 6.548H8.187Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol